import { Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Projectregel } from '../dto/projectregel';
import { CrudService, Filter, FilterOperator } from '@mango/core';
import { Relatie } from '../dto/relatie';
import { map } from 'rxjs/operators';
import { Project } from '../dto/project';
import { createPakbon } from '../dto/createpakbon';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ProjectregelService extends CrudService<Projectregel> {

    constructor(injector: Injector) { super(Projectregel, injector); }

    addinstrument(barcode: string, project: Project) {  
        return this.http.post(`api/dto/projectregel/addinstrument?barcode=${barcode}&projectId=${project.id}`, null).pipe(map(x => x as ProjectregelResponse));
    }

    
    getProjectFilter(project: Project): Filter<Projectregel> {

        if (project != null) {
            return new Filter<Projectregel>(fb => [fb.equal("project",project.id)]);
        }
        else {
            return new Filter<Projectregel>(fb => [fb.equal("project",-1)]);
        }
    }

    WerkbonGenereren(projectregel: Projectregel) {
        let query: string = `api/dto/projectregel/WerkbonGenereren?projectregelId=${projectregel.id}`;

        return this.http.post(query, null).pipe(map(x => x as ProjectregelResponse));

    }

    Kalibratie(projectregel: Projectregel) {
        let query: string = `api/dto/projectregel/Kalibratie?projectregelId=${projectregel.id}`;

        return this.http.post(query, null).pipe(map(x => x as ProjectregelResponse));

    }

    RvAValidatie(projectregel: Projectregel) {
        let query: string = `api/dto/projectregel/RvAValidatie?projectregelId=${projectregel.id}`;

        return this.http.post(query, null).pipe(map(x => x as ProjectregelResponse));

    }

    Reparatie(projectregel: Projectregel) {
        let query: string = `api/dto/projectregel/Reparatie?projectregelId=${projectregel.id}`;

        return this.http.post(query, null).pipe(map(x => x as ProjectregelResponse));

    }

    Uitbesteed(projectregel: Projectregel) {
        let query: string = `api/dto/projectregel/Uitbesteed?projectregelId=${projectregel.id}`;

        return this.http.post(query, null).pipe(map(x => x as ProjectregelResponse));

    }

    UitbesteedAkkoord(projectregel: Projectregel) {
        let query: string = `api/dto/projectregel/UitbesteedAkkoord?projectregelId=${projectregel.id}`;

        return this.http.post(query, null).pipe(map(x => x as ProjectregelResponse));

    }

    Justeren(projectregel: Projectregel) {
        let query: string = `api/dto/projectregel/Justeren?projectregelId=${projectregel.id}`;

        return this.http.post(query, null).pipe(map(x => x as ProjectregelResponse));

    }

    Publiceren(projectregel: Projectregel) {
        let query: string = `api/dto/projectregel/Publiceren?projectregelId=${projectregel.id}`;

        return this.http.post(query, null).pipe(map(x => x as ProjectregelResponse));

    }

    Gereed(projectregel: Projectregel) {
        let query: string = `api/dto/projectregel/Gereed?projectregelId=${projectregel.id}`;

        return this.http.post(query, null).pipe(map(x => x as ProjectregelResponse));

    }

    Verwerkt(projectregel: Projectregel) {
        let query: string = `api/dto/projectregel/Verwerkt?projectregelId=${projectregel.id}`;

        return this.http.post(query, null).pipe(map(x => x as ProjectregelResponse));

    }

    Afkeuren(projectregel: Projectregel) {
        let query: string = `api/dto/projectregel/Afkeur?projectregelId=${projectregel.id}`;

        return this.http.post(query, null).pipe(map(x => x as ProjectregelResponse));

    } 

    Checklist(projectregel: Projectregel) {
        let query: string = `api/dto/projectregel/Checklist?projectregelId=${projectregel.id}`;

        return this.http.post(query, null).pipe(map(x => x as ProjectregelResponse));

    }    

    Revisie(projectregel: Projectregel) {
        let query: string = `api/dto/projectregel/Revisie?projectregelId=${projectregel.id}`;

        return this.http.post(query, null).pipe(map(x => x as ProjectregelResponse));

    }    


    KalibratieStickerMetDatum(projectregel: Projectregel, aantal: number) {
        let query: string = `api/dto/projectregel/KalibratieMetDatum?projectregelId=${projectregel.id}&aantal=${aantal}`;

        return this.http.post(query, null).pipe(map(x => x as ProjectregelResponse));

    }

    KalibratieStickerZonderDatum(projectregel: Projectregel, aantal: number) {
        let query: string = `api/dto/projectregel/KalibratieZonderDatum?projectregelId=${projectregel.id}&aantal=${aantal}`;

        return this.http.post(query, null).pipe(map(x => x as ProjectregelResponse));

    }

    FunctieTestStickerMetDatum(projectregel: Projectregel, aantal: number) {
        let query: string = `api/dto/projectregel/FunctieTestMetDatum?projectregelId=${projectregel.id}&aantal=${aantal}`;

        return this.http.post(query, null).pipe(map(x => x as ProjectregelResponse));

    }

    FunctieTestStickerZonderDatum(projectregel: Projectregel, aantal: number) {
        let query: string = `api/dto/projectregel/FunctieTestZonderDatum?projectregelId=${projectregel.id}&aantal=${aantal}`;

        return this.http.post(query, null).pipe(map(x => x as ProjectregelResponse));

    }

    exportPDF(projectregel: Projectregel) {
        let query: string = `api/dto/projectregel/SavePDF?projectregelId=${projectregel.id}`;

        return this.http.post(query, null).pipe(map(x => x as ProjectregelResponse));

    }

    UitbesteedBevestigingKlant(projectregel: Projectregel) {

        let query: string = `api/dto/projectregel/UitbesteedBevestigingKlant?projectregelId=${projectregel.id}`;

        return this.http.post(query, null).pipe(map(x => x as UitbesteedResponse));
    }

    UitbesteedBevestigingLeverancier(projectregel: Projectregel) {

        let query: string = `api/dto/projectregel/UitbesteedBevestigingLeverancier?projectregelId=${projectregel.id}`;

        return this.http.post(query, null).pipe(map(x => x as UitbesteedResponse));
    }

    UitbesteedBevestigingLeverancierPrint(projectregel: Projectregel) {

        let query: string = `api/dto/projectregel/UitbesteedBevestigingLeverancierPrint?projectregelId=${projectregel.id}`;

        return this.http.post(query, null).pipe(map(x => x as UitbesteedResponse));
    }

    UitbesteedPrijsopgaveKlant(projectregel: Projectregel) {

        let query: string = `api/dto/projectregel/UitbesteedPrijsopgaveKlant?projectregelId=${projectregel.id}`;

        return this.http.post(query, null).pipe(map(x => x as UitbesteedResponse));
    }

    GenerateQRCode(projectregel: Projectregel) {

        let query: string = `api/dto/projectregel/GenerateQRCode?projectregelId=${projectregel.id}`;

        return this.http.post(query, null).pipe(map(x => x as ProjectregelResponse));
    }

    createPakbonnen(projectregels: Projectregel[]) {
        var createPb = new createPakbon();
        createPb.projectregels = projectregels;

        let query: string = `api/dto/projectregel/createPakbon`;

        return this.http.post(query, createPb).pipe(map(x => x as CreatePakbonResponse));
    }

    DownloadCertificaat(id: number) {

        let query: string = `api/dto/projectregel/DownloadCertificaat?projectregelId=${id}`;

        return this.http.post(query, null).pipe(map(x => x as DocumentDownloadResponse));
    }

    DownloadChecklist(id: number) {

        let query: string = `api/dto/projectregel/DownloadChecklist?projectregelId=${id}`;

        return this.http.post(query, null).pipe(map(x => x as DocumentDownloadResponse));
    }

    DownloadBevestiging(id: number) {

        let query: string = `api/dto/projectregel/DownloadOrderbevestiging?projectregelId=${id}`;

        return this.http.post(query, null).pipe(map(x => x as DocumentDownloadResponse));
    }

    DownloadWerkbon(id: number) {

        let query: string = `api/dto/projectregel/DownloadWerkbon?projectregelId=${id}`;

        return this.http.post(query, null).pipe(map(x => x as DocumentDownloadResponse));
    }

    DownloadUitbesteedPrijsopgaveKlant(id: number) {

        let query: string = `api/dto/projectregel/DownloadUitbesteed?projectregelId=${id}&document=1`;

        return this.http.post(query, null).pipe(map(x => x as DocumentDownloadResponse));
    }

    DownloadUitbesteedBevestigingKlant(id: number) {

        let query: string = `api/dto/projectregel/DownloadUitbesteed?projectregelId=${id}&document=2`;

        return this.http.post(query, null).pipe(map(x => x as DocumentDownloadResponse));
    }

    DownloadUitbesteedLeverancier(id: number) {

        let query: string = `api/dto/projectregel/DownloadUitbesteed?projectregelId=${id}&document=3`;

        return this.http.post(query, null).pipe(map(x => x as DocumentDownloadResponse));
    }

    DownloadCertificaatWerkstandaard(id: number, werkstandaard: number) {

        let query: string = `api/dto/projectregel/DownloadCertificaatWerkstandaard?projectregelId=${id}&werkstandaard=${werkstandaard}`;

        return this.http.post(query, null).pipe(map(x => x as DocumentDownloadResponse));
    }

    exportCertificaatCentix(id: number) {

        let query: string = `api/dto/projectregel/ExportCertificaatCentix?projectregelId=${id}`;

        return this.http.post(query, null).pipe(map(x => x as ProjectregelResponse));
    }
    
    openDirectory(dir: string) {

        let query: string = `http://localhost:3000/?location=${dir}`;

        window.open(query,"_blank");

    }
   
    ConvertResponseToBlob(response: DocumentDownloadResponse, sliceSize = 512) {
        const byteCharacters = atob(response.file);
        const byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            const slice = byteCharacters.slice(offset, offset + sliceSize);

            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }

        const blob = new Blob(byteArrays, { type: response.fileMimeType });
        return blob;
    }

    getImage(url: string): Observable<Blob> {
        return this.http.get(url, {responseType: 'blob'})
    }

    downloadHistorie(filter: Filter<Projectregel>, historie: boolean) {
        
        let f = `filter=${encodeURIComponent(JSON.stringify(this.convertFilter(filter) ))}`;
        let query: string = `/api/dto/projectregel/DownloadHistorie?${f}&historie=` + historie;
             
        return this.http.post(query, null).pipe(map(x => x as DocumentDownloadResponse));
    }
        
    private convertFilter (f: Filter<Projectregel>, arr: any[] = [] ) {
        for(let fp of f.getProperties()) {
            arr.push(fp);
        };

        let isEmpty = (str)=>typeof(str)=='string' && str.trim() == "";

        Object.keys(f).forEach(x => {
            if(Object.keys(new Filter<Projectregel>()).indexOf(x) === -1 && f[x] != null && !isEmpty(f[x])) {
                let customProperty = {};
                customProperty[x] = f[x];
                arr.push(customProperty);
            }
        });

        f.filters.forEach(subF => {
            let andOrItem = {};
            let subArr = [];
            this.convertFilter(subF, subArr);
            andOrItem[subF.filterOperator == FilterOperator.And ? "and" : "or"] = subArr;
            arr.push(andOrItem);
        });

        return arr;
    }

}

export class CreatePakbonResponse {
    successful: boolean;
    message: string;
    pakbonId: number;
}

export class ProjectregelResponse {
    successful: boolean;
    message: string;
    directory: string;
}

export class UitbesteedResponse {
    successful: boolean;
    message: string;
    filename: string;
    attachment: string;
}

export class DocumentDownloadResponse {
    file: string;
    successful: boolean;
    fileName: string;
    fileMimeType:string;
}

